import OverviewInterface from './OverviewInterface'

class ThirdOverview extends OverviewInterface {
    constructor(){
        super()
        this.linkedtype = 'third'
        this.fetchRoute = "overview.third.init"
    }

    getSellsyAdminCommonTabs() {
        return this.getMapping().sellsyAdminCommonTabs
    }
    getSamTabs() {
        return this.getMapping().samTabs
    }
}

export default ThirdOverview